var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("footer", { staticClass: "coopba-footer" }, [
    _c("div", { staticClass: "footer-grid" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-col" },
        [
          _c("h4", [_vm._v("Institución")]),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: { path: "/", query: { seccion: "quienes" } } } },
            [_vm._v("Quiénes somos")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: { path: "/", query: { seccion: "quienes" } } } },
            [_vm._v("Autoridades")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: { path: "/", query: { seccion: "quienes" } } } },
            [_vm._v("Estatuto")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: { path: "/", query: { seccion: "quienes" } } } },
            [_vm._v("Historia")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(1),
    ]),
    _vm._v(" "),
    _vm._m(2),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "footer-col" }, [
      _c("p", [
        _vm._v(
          '\n        Asociación civil sin fines de lucro que apoya a la comunidad educativa del Bachillerato de Bellas Artes "Prof.\n        Francisco A. De Santo".\n      '
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "footer-direccion" }, [
        _vm._v("Calle 10 N° 1472 e/ diag. 78 y 63"),
        _c("br"),
        _vm._v("La Plata, Buenos Aires"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "footer-col" }, [
      _c("h4", [_vm._v("Contacto")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "mailto:coopba@gmail.com" } }, [
        _vm._v("coopba@gmail.com"),
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "tel:+542214513185" } }, [
        _vm._v("+54 221 451-3185"),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Lunes a viernes: 8:00–17:00 h")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "footer-bottom" }, [
      _c("p", [
        _vm._v("© 2026 Cooperadora BBA UNLP. Todos los derechos reservados."),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Desarrollo y mantenimiento: Cristian Adrián Cabrera ·\n      "
        ),
        _c("a", { attrs: { href: "mailto:cabrecri@gmail.com" } }, [
          _vm._v("cabrecri@gmail.com"),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Universidad Nacional de La Plata")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }